import request from "@/utils/request";
const RemittebaseUrl = `${process.env.VUE_APP_REMITTE_BASEURL}/api/v1/admin-bene`;
export default {
  getBenificiaryData(custm_id) {
    return request({
      url: `${RemittebaseUrl}/remitter/get-beneficiary-list?customer_id=${custm_id}`,
      method: "GET",
    });
  },
  getDomesticBenificiaryData(custm_id) {
    return request({
      url: `${RemittebaseUrl}/get-domestic-list?customer_id=${custm_id}`,
      method: "GET",
    });
  },
  editBenificiaryData(reciver_id, custm_id) {
    return request({
      url: `${RemittebaseUrl}/get-beneficiary-by-id/${reciver_id}?customer_id=${custm_id}`,
      method: "GET",
    });
  },
  saveBenificiaryData(customer_id, data) {
    return request({
      url: `${RemittebaseUrl}/create-beneficiary?customer_id=${customer_id}`,
      method: "POST",
      data,
    });
  },
  updateBenificiaryData(reciver_id, customer_id, data) {
    return request({
      url: `${RemittebaseUrl}/update-beneficiary/${reciver_id}?customer_id=${customer_id}`,
      method: "PUT",
      data,
    });
  },
  saveBusBenificiaryData(cust_id, data) {
    return request({
      url: `${RemittebaseUrl}/business-beneficiary?customer_id=${cust_id}`,
      method: "POST",
      data,
    });
  },
  updateBusBenificiaryData(reciver_id, data) {
    return request({
      url: `${RemittebaseUrl}/business-beneficiary/${reciver_id}`,
      method: "PUT",
      data,
    });
  },
  deleteBenificiaryData(receiver_id, customer_id) {
    return request({
      url: `${RemittebaseUrl}/delete-beneficiary/${receiver_id}?customer_id=${customer_id}`,
      method: "DELETE",
    });
  },
  getHighestBeneCount() {
    return request({
      url: `${RemittebaseUrl}/get-highest-beneficiary-count`,
      method: "GET",
    });
  },
};
